import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

export const VisitPrescriptionsDetails = ({
  prescriptions,
  prescriptionsRef,
  handleFileDownload,
}) => {
  if (!Array.isArray(prescriptions) || prescriptions.length === 0) {
    return null;
  }

  const formatDateWithoutConversion = (date) => {
    if (!date) {
      return '-';
    }

    const value = String(date);
    const datePart = value.substring(0, 10);
    const timePart = value.substring(11, 16);

    if (!datePart) {
      return '-';
    }

    if (!timePart || timePart === '00:00') {
      return datePart;
    }

    return `${datePart} ${timePart}`;
  };

  const formatDateOnlyWithoutConversion = (date) => {
    if (!date) {
      return '-';
    }

    return String(date).substring(0, 10);
  };

  return (
    <div ref={prescriptionsRef} className="mt-3">
      {prescriptions.map((prescription, index) => (
        <Card key={index} className="mb-4">
          <CardHeader>
            <Heading variant="userAccountDetailsTitle">Receptas</Heading>
          </CardHeader>

          <CardContent className="space-y-4">
            <div>
              <span>Data: </span>
              <span>
                {formatDateWithoutConversion(prescription.dateAsserted)}
              </span>
            </div>

            <div>
              <span>Pavadinimas: </span>
              <span>{prescription.name}</span>
            </div>

            <div>
              <span>Diagnozė: </span>
              <span>{prescription.reason}</span>
            </div>

            <div>
              <span>Kompensacijos rūšis: </span>
              <span>
                {prescription.coverage === null || prescription.coverage === ''
                  ? 'Nekompensuojama'
                  : prescription.coverage}
              </span>
            </div>

            <div>
              <span>Dozavimo rekomendacijos: </span>
              <span>{prescription.dosage || '-'}</span>
            </div>

            <div>
              <span>Galioja nuo: </span>
              <span>
                {formatDateWithoutConversion(
                  prescription.effectiveStartDate,
                )}
              </span>
            </div>

            <div>
              <span>Galioja iki: </span>
              <span>
                {formatDateWithoutConversion(prescription.effectiveEndDate)}
              </span>
            </div>

            {prescription.file?.guid && (
              <div>
                <Button
                  variant="light"
                  onClick={() => {
                    const fileName = `${
                      prescription.name
                    } ${formatDateOnlyWithoutConversion(
                      prescription.dateAsserted,
                    )}`;

                    handleFileDownload(
                      'Prescription',
                      fileName,
                      prescription.file.type,
                      prescription.file.guid,
                    );
                  }}
                >
                  <Download />
                  Atsisiųsti PDF
                </Button>
              </div>
            )}
          </CardContent>

          <CardFooter />
        </Card>
      ))}
    </div>
  );
};